import React from 'react';
import {
  SidebarContainer,
  Icon,
  CloseIcon,
  SidebarLink,
  SidebarMenu,
  SidebarWrapper,
  SidebarBtnWrap,
} from './Sidebar.elements';

const LINKS = [
  { to: 'home', label: 'Home' },
  { to: 'about', label: 'About' },
  { to: 'skills', label: 'Skills' },
  { to: 'experience', label: 'Experience' },
  { to: 'projects', label: 'Projects' },
  { to: 'certifications', label: 'Certifications' },
  { to: 'gallery', label: 'Gallery' },
  { to: 'services', label: 'Services' },
  { to: 'contact', label: 'Contact' },
];

const Sidebar = ({ isOpen, toggle }) => {
  const itemVariants = {
    closed: { opacity: 0, y: 20 },
    open: (i = 0) => ({
      opacity: 1,
      y: 0,
      transition: { delay: 0.06 * i, duration: 0.35, ease: 'easeOut' },
    }),
  };

  return (
    <SidebarContainer
      isOpen={isOpen}
      onClick={toggle}
      initial={false}
      animate={{
        opacity: isOpen ? 1 : 0,
        scale: isOpen ? 1 : 1.04,
      }}
      transition={{ duration: 0.3, ease: 'easeInOut' }}
    >
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>
      <SidebarWrapper>
        <SidebarMenu>
          {LINKS.map((l, i) => (
            <SidebarBtnWrap
              key={l.to}
              custom={i}
              variants={itemVariants}
              initial="closed"
              animate={isOpen ? 'open' : 'closed'}
            >
              <SidebarLink
                onClick={toggle}
                to={l.to}
                smooth
                duration={500}
                spy
                exact="true"
                offset={-70}
              >
                {l.label}
              </SidebarLink>
            </SidebarBtnWrap>
          ))}
        </SidebarMenu>
      </SidebarWrapper>
    </SidebarContainer>
  );
};

export default Sidebar;
